module.exports = __webpack_public_path__ + "prod/20260929161836/img/officialAccount.85b10ff1.jpg";